import { Injectable } from '@angular/core';
import { stripGeneratedFileSuffix } from '@angular/compiler/src/aot/util';
import { Time } from '@angular/common';

@Injectable ()
export class SharedService {
 // URL = 'http://127.0.0.1:88';
 // URLnode = 'http://127.0.0.1:2136'; // server

  //test env
  // URLnode = 'http://160.119.101.133:2139'; // server
  // URL = 'http://160.119.101.133:2140'; // server

  //PRD
    //ng build --prod --base-href http://www.commalongadmin.co.za
    URL = 'https://cbl.commalong.co.za'; // server
    URLnode = 'https://nbl.commalong.co.za'; // server
    

    versionNo = '1.1.9';

    UserLevel: number

    notificationMessages = {
      successUpdate: 'Record(s) Updated',
      successInsert: 'Record(s) Added',
      successDelete: 'Record(s) Deleted',
      failedUpdate: 'Record(s) Updated Failed',
      failedInsert: 'Record(s) Added Failed',
      failedDelete: 'Record(s) Deleted Failed',
      smsSent: 'SMS has been send',
      smsFail: 'SMS failed to send',
      emailSent: 'Email has been send',
      emailFail: 'Email failed to send'
    }

    loadingActive = false;
    dateFormatString = "dd/MM/yyyy HH:mm";
    dateFormatStringNoTime = "dd/MM/yyyy";

    /* SETUP FOR MOST "LIST" DATAGRIDS
      NBBBBBB: CHANGE THE STORAGE KEY BELOW FOR EACH TABLE (KEEP IT UNIQUE)
      NBBBBBB: CHANGE THE STORAGE KEY BELOW FOR EACH TABLE (KEEP IT UNIQUE)
      NBBBBBB: CHANGE THE STORAGE KEY BELOW FOR EACH TABLE (KEEP IT UNIQUE)

      <dxo-state-storing storageKey="tripsComponentGrid" [enabled]="true" type="sessionStorage"></dxo-state-storing>
      <dxo-paging [enabled]="true"></dxo-paging>
      <dxo-export [enabled]="true" [allowExportSelectedData]="true" fileName="NewFileName"></dxo-export>
      <dxo-group-panel [visible]="true"></dxo-group-panel>
      <dxo-grouping [autoExpandAll]="false"></dxo-grouping>
      <dxo-search-panel [visible]="true" [width]="240"></dxo-search-panel>
      <dxo-selection mode="multiple"></dxo-selection>
    */
}

export class Batch {
    id: number;
    customer: string;
    pickUpDate: string;
    pickupDateTime: string;
    dropOffDate: string;
    dropOffDateTime: string;
    stopsAddress: string;
    pickUpAddress: string;
    pickUpInstructions: string;
    dropOffAddress: string;
    numberOfPoeple: string;
    dropOffInstructions: string;
    emailAddress: string;
  }

